import React, { ComponentProps, JSX } from 'react';
import { Heading } from '@chakra-ui/react';

export const PageHeading = ({ ...props }: ComponentProps<typeof Heading>): JSX.Element => (
  <Heading variant="pageHeading" mb={2} as={props.as || 'h1'} {...props}>
    {props.children}
  </Heading>
);
